import LocalAssetsViewer from "../../common/LocalAssetsViewer";
import { Asset } from "../../../types";

export interface PreviewableDocument {
  id: string;
  url: string;
  filename?: string | null;
}

// Image extensions the viewer renders via the image path (ReactPanZoom). Anything
// else is treated as a PDF and rendered via `<embed>`.
const IMAGE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "heic",
  "heif",
  "tiff",
  "bmp",
];

// `Asset.filetype` is a required string, but the filename is an unreliable source
// of truth: it can be null, carry no extension (e.g. "document"), or - for
// smarta-documents (SevDesk / BuchhaltungsButler) synced receipts - end in a
// malformed, doubled tail with a spurious dot, so `split(".").pop()` yields garbage
// instead of "pdf" (SMT-1027). Only treat a known image extension as an image;
// everything else defaults to "pdf", the dominant receipt type and the established
// fallback elsewhere in the app.
const getFiletype = (filename?: string | null): string => {
  const extension = filename?.split(".").pop()?.toLowerCase();
  if (extension && IMAGE_EXTENSIONS.includes(extension)) return extension;
  return "pdf";
};

export const getAsset = (doc: PreviewableDocument): Asset => ({
  id: doc.id,
  fullsize: doc.url,
  filetype: getFiletype(doc.filename),
});

/**
 * Lean document preview — just the asset viewer, no delete / send-to-customer /
 * fetchNext controls. Reused by both BelegeView's EmailDocumentPreview and the
 * Receipt Overview detail panel (SMT-877).
 */
export const EmailDocumentPreviewOnly = ({
  emailDocument,
  minHeight = 850,
}: {
  emailDocument: PreviewableDocument;
  minHeight?: number;
}) => (
  <LocalAssetsViewer assets={[getAsset(emailDocument)]} minHeight={minHeight} />
);

export default EmailDocumentPreviewOnly;
